import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useEffect } from "react";
import appStoreLogo from '../public/images/app_store.png';
import downloadQr from '../public/images/download_qr.png';
import playStoreLogo from '../public/images/play_store.png';
import wordmark from '../public/images/wordmark.png';
import styles from '../styles/Download.module.css';
import { getMobileOs } from '../util';

export const APP_STORE_LINK = "https://apps.apple.com/us/app/pearl-poap-inbox/id6443767528";
export const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.pearl.poapinbox";

const Download = () => {
    const router = useRouter();

    useEffect(() => {
        if (!router.isReady) {
            return;
        }

        if (getMobileOs() === "iOS") {
            window.location.replace(APP_STORE_LINK);
        } else if (getMobileOs() === "Android") {
            window.location.replace(PLAY_STORE_LINK);
        }
    }, [router]);

    return <div className={styles.container}>
        <Image src={wordmark} width={200} height={66} alt="Salsa wordmark" />
        <h2 className={styles.text}>Scan to download</h2>
        <Image className={styles.qrCode} src={downloadQr} width={180} height={180} alt="Download QR code" />
        <div className={styles.logos}>
            <a className={styles.logo} href={APP_STORE_LINK} target="_blank" rel="noreferrer">
                <Image src={appStoreLogo} alt="App Store logo" />
            </a>
            <a className={styles.logo} href={PLAY_STORE_LINK} target="_blank" rel="noreferrer">
                <Image src={playStoreLogo} alt="Play Store logo" />
            </a>
        </div>
    </div>;
}

export default Download;